// extracted by mini-css-extract-plugin
var _1 = "w88h4";
var _2 = "OWuP9";
var _3 = "do2Kb";
var _4 = "MPkbq";
export { _1 as "base", _2 as "collapsible", _3 as "isCollapsed", _4 as "trigger" }
